import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import {
  getPrograms,
  getInstitutionPrograms,
  getInstitutionProgramsFilter,
} from "../../slices/codeBookSlice";

export const useGetPrograms = () => {
  const programs = useSelector((state: RootState) => state.codeBook.programs);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPrograms());
  }, [dispatch]);

  return programs;
};

export const useGetInstitutionPrograms = (
  pedagogicalYearInstitutionId: number
) => {
  const filteredPrograms = useSelector(
    (state: RootState) => state.codeBook.filteredPrograms
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInstitutionPrograms(pedagogicalYearInstitutionId));
  }, [pedagogicalYearInstitutionId, dispatch]);

  return filteredPrograms;
};

export const useGetInstitutionProgramsFilter = (
  pedagogicalYearInstitutionId: number,
  parentIntitutionId?: number
) => {
  const filteredPrograms = useSelector(
    (state: RootState) => state.codeBook.filteredPrograms
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getInstitutionProgramsFilter({
        pedagogicalYearInstitutionId,
        parentIntitutionId,
      })
    );
  }, [pedagogicalYearInstitutionId, parentIntitutionId, dispatch]);

  return filteredPrograms;
};
